var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 337,
    height: 677,
    fill: "none",
    viewBox: "0 0 337 677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1F3",
    d: "M337 238.032V49.462C315.358 24.73 278.257 0 194.78 0 64.927 0 18.55 86.557 18.55 176.205c0 105.105 74.202 157.658 74.202 250.398 0 40.187-46.376 52.552-92.752 15.456v200.936C37.424 666.891 68.018 677 123.67 677c61.835 0 160.77-43.279 160.77-173.114 0-142.201-55.651-157.658-55.651-250.397 0-52.553 61.835-55.644 108.211-15.457Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve);
export default __webpack_public_path__ + "static/media/curve.78ca163b7b919e256078de7fb3948b13.svg";
export { ForwardRef as ReactComponent };